import { AboutContainer } from "../../components";
import * as Styled from "./about-page.styled";

export const AboutPage = () => {
  return (
    <Styled.AboutPageWrapper>
      <AboutContainer />
    </Styled.AboutPageWrapper>
  );
};
